import React from 'react';
import classnames from 'classnames';

import s from './WideWidgetLayout.scss';

export interface Props {
  header?: string;
  subSubheader?: string;
  navigation: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const WideWidgetLayout: React.FC<Props> = ({
  header,
  subSubheader,
  navigation,
  children,
  className,
}) => {
  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['navigation']}>{navigation}</div>
      <div className={s['content-column']}>
        {header && (
          <h1 className={s['header']}>
            <div>{header}</div>
          </h1>
        )}
        {subSubheader && <div className={s['subheader']}>{subSubheader}</div>}
        <div className={s['widgets']}>{children}</div>
      </div>
    </div>
  );
};
WideWidgetLayout.displayName = 'WideWidgetLayout';

export default WideWidgetLayout;
